var PearsonAccordionPlugin = new PearsonAccordion({
    componentClass: '.c-accordion-group',
    toggleClass:'isActive',
    showListClass:'c-accordion__trigger',
    listClass: 'c-accordion-panel'
});
